<template>
  	<div class="loading" >
        <div v-loading="true" element-loading-text="正在跳转到首页"></div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'  
import axios from 'axios';
import getRequest from '../utils/getRequest.js';
import  setLocalStorage from '../utils/setLocalStorage.js'
import {clearAllCookie} from '../io/getCookie.js'
export default {
	data(){
		return{
		
		}
	},
	mounted(){
		this.init()
	}, 
	methods:{
		async init(){
			var url = window.location.href; 
            let loginType = getRequest(url)['loginType'];
			window.localStorage.setItem("loginType", loginType);
			Cookies.set('loginType', loginType, { expires: 1 });  
				//access_token是后台所指定的key
			let code = url.split('?')[1]; 
			let redirectUrl = `redirectUrl=${window.location.origin}/knowservePlatform/login?loginType=${loginType}&${code}`
            let res  = await axios.get(`/callback?${redirectUrl}`,{ transformRequest: [(data, headers) => {
                delete headers.Authorization;
                delete headers['Authorization'] 
                return data 
            }] })
			if(res&&res.data.code==0){  
				//和刷新token存储的值保持一致
				setLocalStorage(res.data)  ; 
				Cookies.set('yianInfo', JSON.stringify (res.data), { expires: 1 });  
				// return 
				window.open('./homePage','_self')
			}else{
				window.localStorage.clear();  
				clearAllCookie();
				this.$message.error(res.data.msg||'请求失败～')
			}

		},
		//清空cookies 和 localStorage
		clearAll() {
			window.localStorage.clear();
			window.sessionStorage.clear();
			const cookies = Cookies.get(); // 获取所有的cookies
			for (const cookie in cookies) {
				Cookies.remove(cookie); // 逐个移除cookie
			}
			console.log('所有的Cookies已被清除');
		},
	}
}
</script>

<style lang="less" scoped>
.loading{
    text-align: center;
    padding-top:100px;
    min-height: 1000px;
}
</style>